<template>
  <b-container>
    <b-row>
      <b-col v-bind="container" class="panel-wrapper px-4">
        <header class="mb-2">
          <b-row>
            <b-col>
              <slot name="header"></slot>
            </b-col>
          </b-row>
        </header>
        <slot name="message-panel"></slot>
        <slot></slot>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: 'BaseContainer',
  data() {
    return {
      container: {
        cols: 12,
        sm: 12,
        md: 8,
        offsetMd: 2,
        lg: 6,
        offsetLg: 3,
        xl: 6,
        offsetXl: 3,
      },
    };
  },
};
</script>

<style lang="scss" scoped>
@import '@docupet/component-library/src/assets/styles/_variables';
.panel-wrapper {
  padding: 2rem;
  background-color: $dp-white;
}
@media screen and (min-width: 576px) {
  .panel-wrapper {
    border-radius: 8px;
    box-shadow: 1px 2px 3px $dp-shadow-1;
    overflow: hidden;
  }
}
</style>
